export default __webpack_public_path__ + "static/media/banner-image.5083f141.png";